<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <section>
            <h1 class="pb-5">General</h1>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Form Type</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li v-for="type in types" :key="type">
                    <vs-radio v-model="form.form_type" :vs-value="type">{{
                      type
                    }}</vs-radio>
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Form Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="form_title"
                  class="w-full"
                  v-model="form.form_title"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('form_title')"
                  >{{ errors.first("form_title") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mb-10">
                <quill-editor
                  class="editor"
                  v-model="form.form_shortdesc"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                >
                  <div id="toolbar" slot="toolbar">
                    <!-- Add a bold button -->
                    <button class="ql-bold">Bold</button>
                    <button class="ql-italic">Italic</button>
                    <!-- Add font size dropdown -->
                    <select class="ql-size">
                      <option value="small"></option>
                      <!-- Note a missing, thus falsy value, is used to reset to default -->
                      <option selected></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                    <select class="ql-font">
                      <option selected="selected"></option>
                      <option value="serif"></option>
                      <option value="monospace"></option>
                    </select>
                    <!-- Add subscript and superscript buttons -->
                    <button class="ql-script" value="sub"></button>
                    <button class="ql-script" value="super"></button>
                  </div>
                </quill-editor>
                <vs-textarea
                  style="display: none"
                  class="w-full"
                  v-model="form.form_shortdesc"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Long Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mb-10">
                <quill-editor
                  class="editor"
                  v-model="form.form_longdesc"
                  :options="editorOption2"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                >
                  <div id="toolbar2" slot="toolbar">
                    <!-- Add a bold button -->
                    <button class="ql-bold">Bold</button>
                    <button class="ql-italic">Italic</button>
                    <!-- Add font size dropdown -->
                    <select class="ql-size">
                      <option value="small"></option>
                      <!-- Note a missing, thus falsy value, is used to reset to default -->
                      <option selected></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                    <select class="ql-font">
                      <option selected="selected"></option>
                      <option value="serif"></option>
                      <option value="monospace"></option>
                    </select>
                    <!-- Add subscript and superscript buttons -->
                    <button class="ql-script" value="sub"></button>
                    <button class="ql-script" value="super"></button>
                  </div>
                </quill-editor>
                <vs-textarea
                  style="display: none"
                  class="w-full"
                  v-model="form.form_longdesc"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Is anonymous </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <b-form-checkbox
                  v-model="form.is_anonymous"
                  class="custom-control-danger"
                  name="check-button"
                  switch
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <label for="datepicker-start">Start</label>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <el-date-picker
                  v-model="form.datetime_start"
                  type="datetime"
                  placeholder="Start date"
                  value-format="yyyy-MM-dd HH:mm"
                  format="dd-MM-yyyy HH:mm"
                  :picker-options="StartPickerOptions"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>End</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <el-date-picker
                  v-model="form.datetime_end"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm"
                  placeholder="End date"
                  format="dd-MM-yyyy HH:mm"
                  :picker-options="EndPickerOptions"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Auth required</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <b-form-checkbox
                  v-model="form.auth_required"
                  class="custom-control-danger"
                  name="check-button"
                  switch
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Publish status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <b-form-checkbox
                  v-model="form.publish_status"
                  class="custom-control-danger"
                  name="check-button"
                  switch
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>listing_status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <b-form-checkbox
                  v-model="form.listing_status"
                  class="custom-control-danger"
                  name="check-button"
                  switch
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>weight</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="form.weight" maxlength="3" />
              </div>
            </div>
          </section>

          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Create Form</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";
import Service from "@/services";
import { mapState } from "vuex";
import moment from "moment";
const short = require('short-uuid');
const translator = short();

const dict = {
  form: {
    form_title: {
      required: "Please enter an form name",
    },
  },
};

Validator.localize("en", dict);

export default {
  data() {
    // text, checkbox, radio, amendment-text, amendment-radio,amendment-checkbox, birthday, country, citizenid, image
    const types = [
      "attendee-info",
      "post-event-survey",
      "pre-event-interest",
      "vote",
    ];
    const trueOrFalse = [
      { id: 1, name: "true" },
      { id: 0, name: "false" },
    ];

    return {
      types: types,
      anonymous: trueOrFalse,
      trueOrFalse: trueOrFalse,
      valid: true,
      editorOption: {
        modules: {
          toolbar: "#toolbar",
        },
      },
      editorOption2: {
        modules: {
          toolbar: "#toolbar2",
        },
      },

      StartPickerOptions: {},
      EndPickerOptions: {},

      // default data
      form: {
        event_id: null,
        form_type: "attendee-info",
        form_title: "",
        form_shortdesc: "",
        form_longdesc: "",
        is_anonymous: 1,
        datetime_start: "",
        datetime_end: "",
        auth_required: 0,
        publish_status: true,
        listing_status: true,
        weight: "",

        consent_step: "before",
        eligible_role: null,
      },
    };
  },

  computed: {
    ...mapState({
      s: (state) => {
        return state.Utility.s;
      },
      e: (state) => {
        return state.Utility.e;
      },
    }),
  },

  created() {
    this.form.s = this.s;
    Service.Event.get(this.e)
      .then((res) => {
        if (res.success) {
          const event = res.data.event;
          this.form.event_id = event.event_id;
        }
      })
      .catch((e) => {
        /* this.$router.push("/pages/error-404").catch(() => {}); */
      });
  },

  watch: {
    "form.form_title": function (newVal) {
      var slugify = require("slugify");
      this.form.slug = slugify(newVal, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove:
          /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false, // strip special characters except replacement, defaults to `false`
      });

      if (this.form.slug.match(/(\w+)/g).length > 5) {
        var words = this.form.slug.split("-");
        this.form.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    },
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    onEditorBlur() {},
    onEditorFocus() {},
    submit() {
      this.$vs.loading();

      this.form = {
        ...this.form,
        ...this.currencyForm,
        ticket: this.ticketForm,
        form_uuid: translator.new()
      };

      Service.Question.create(this.form)
        .then((res) => {
          if (res.success) {
            const data = res.data;
            const dataForm = data.form;

            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success",
            });

            this.$router.push("/forms/"+data.form.form_id);
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger",
          });
          this.$vs.loading.close();
        });

      console.log("submit loading...", this.form);
    },
  },
};
</script>
<style scoped>
.remove-content-button {
  cursor: pointer;
  color: red;
  margin-left: 10px;
  /* position: absolute;
  right: 5px;
  top: 0; */
  font-size: 30px;
}
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 100px;
}

.tooltip-menu div {
  cursor: pointer;
  padding: 5px;
}

/* Style the 3 dots icon (you may need to adjust this based on your icon library) */
i.fas.fa-ellipsis-v {
  cursor: pointer;
}
.ghost {
  /* background: red; */
  background: #f8f8f8;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transpage: translateX(30px);
}
.filter-table * {
  font-size: 1.3rem !important;
}

.sticky-menu {
  background-color: #fff;
  padding: 1rem;
  position: sticky;
  top: 62px;
  z-index: 999;
}

.sticky-menu .sticking {
  background-color: #fff;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.3);
}
input[type="file"] {
			display: none !important;
		}
</style>

<style>
.con-vs-tabs,
.vs-card--content {
  overflow: visible !important;
}

.filter-table .vs__selected {
  font-size: 1.1rem !important;
}
.filter-popup .vs-popup {
  height: 400px !important;
}

.filter-popup .vs-popup--content {
  height: 100%;
  overflow: visible;
  position: relative;
}

.suggested-popup .vs-popup--content {
  height: 100%;
  overflow: visible;
  position: relative;
}
.vs-input--placeholder.large {
  font-size: 1.2rem;
}

div.page-title input.vs-input--input {
  font-size: 1.8rem !important;
}

div.page-title .vs-input--placeholder {
  font-size: 1.8rem;
}
.content-popup .vs-popup {
  height: 400px !important;
}
</style>
